const buttonRipple = () => {
  const settings = {
    buttonSelector: '.btn',
    rippleClassName: 'ripple',
    rippleColor: 'rgba(255, 255, 255, 0.2)'
  }

  const buttons = document.querySelectorAll(settings.buttonSelector)

  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const buttonTop = e.target.getBoundingClientRect().top
      const buttonLeft = e.target.getBoundingClientRect().left
      const xInside = e.clientX - buttonLeft
      const yInside = e.clientY - buttonTop

      const circle = document.createElement('span')
      circle.classList.add(settings.rippleClassName)
      circle.style.backgroundColor = settings.rippleColor
      circle.style.top = `${yInside}px`
      circle.style.left = `${xInside}px`

      this.appendChild(circle)
      setTimeout(() => {
        circle.remove()
      }, 500)
    })
  })
}

export default buttonRipple
